export var DEFAULT_DESKTOP_MIN_WIDTH = "".concat(1025 / 16, "em");
export var DEFAULT_TABLET_MIN_WIDTH = "".concat(768 / 16, "em");
export var DEFAULT_TABLET_MAX_WIDTH = "".concat(1024 / 16, "em");
export var DEFAULT_PHONE_MAX_WIDTH = "".concat(767 / 16, "em");
export var DEFAULT_DESKTOP_LARGE_MIN_WIDTH = "".concat(1280 / 16, "em");
//# sourceMappingURL=constants.js.map